import { useSupabaseTable } from './useSupabaseTable';

// Fechamentos de cambio (NDF) — tabela nf.cambio_fechamentos.
// Ordena por created_at desc por padrao (mais recente primeiro).
export function useCambio() {
  return useSupabaseTable('cambio_fechamentos', {
    orderBy: 'created_at',
    ascending: false,
  });
}
